module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-31-0df4eec239c0750d56d86fd831f83ef7.svg";